import { Typography } from "@circleco/compass/components/Typography";

import { CircleAIDockNavLink } from "./CircleAIDockNavLink";
import type { DockNavSection } from "./types";

interface CircleAIDockNavSectionProps {
  section: DockNavSection;
}

export const CircleAIDockNavSection = ({
  section,
}: CircleAIDockNavSectionProps) => {
  if (section.items.length === 0) return null;

  return (
    <div className="flex flex-col gap-0.5 px-3 py-2">
      {section.title && (
        <Typography
          variant="label-sm"
          color="tertiary"
          component="h2"
          className="px-3 pb-1 pt-2"
        >
          {section.title}
        </Typography>
      )}
      {section.items.map(item => (
        <CircleAIDockNavLink key={item.id} item={item} />
      ))}
    </div>
  );
};
